<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        
        <CCardBody class="tips_financial_table_modify">
            <h5>{{ title }}</h5>
            <CDataTable
                :items="items"
                :fields="fields"
                hover
                sorter
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">
                    <tr class="first_tr">
                        <th colspan="1" style="min-width: 150px;"></th>
                        <th colspan="1" style="min-width: 200px;"></th>
                        <th colspan="1" style="min-width: 100px;"></th> 
                        <th colspan="1" style="min-width: 100px;"></th>
                        <th colspan="1" style="min-width: 100px;"></th>
                        <th colspan="2" style="min-width: 150px;">{{ $t('avg Odds Bet365') }}</th>
                        <th colspan="2" style="min-width: 150px;">{{ $t('avg Entry odds') }}</th>
                        <th colspan="2" style="min-width: 150px;">{{ $t('avg CO odds') }}</th>
                        <th colspan="5" style="min-width: 250px;">{{ $t('Profits in row') }}</th>
                        <th colspan="5" style="min-width: 250px;">{{ $t('Losses in row') }}</th>
                        <th colspan="1" style="min-width: 160px;"></th>
                    </tr>
                   
                </template>
                <template #last_bet="{item, index}">
                    
                    <td>
                        <span :class="{'outcome-col': true, 'green-background' : item['last_bet'] == 'V', 'red-background' : item['last_bet'] == 'F'}">{{item.last_bet}}</span>
                    </td>
                </template>

                

            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'FinancialLeagueTable',
    components: {
        Plotly,
       
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        title: {
            type: String
        }
    },
    data () {
        return {
            fields: [
                { key: 'Country', label: this.$t('Country')},
                { key: 'League', label: this.$t('League')},
                { key: 'Sample', label: this.$t('Sample')},
                
                { key: 'Win Rate', label: this.$t('Win Rate')},

                { key: 'profit_factor', label: this.$t('Profit factor')},
                
                { key: 'avg Bet 365 Entry', label: this.$t('Entry')},
                { key: 'avg Bet 365 CO Odds', label: this.$t('CashOut')},
               
                { key: 'avg_entry_back_odd', label: this.$t('Back')},
                { key: 'avg_entry_lay_odd', label: this.$t('Lay')},
                { key: 'avg_cashout_back_odd', label: this.$t('Back')},
                { key: 'avg_cashout_lay_odd', label: this.$t('Lay')},
               
                { key: 'recent_max_win_repeat', label: this.$t('current')},
                { key: 'win_avg', label: this.$t('avg')},
                { key: 'win_trend1', label: this.$t('trend 1')},
                { key: 'win_trend2', label: this.$t('trend 2')},
                { key: 'max_win_repeat', label: this.$t('best')},
                { key: 'recent_max_loss_repeat', label: this.$t('current')},
                { key: 'loss_avg', label: this.$t('avg')},
                { key: 'loss_trend1', label: this.$t('trend 1')},
                { key: 'loss_trend2', label: this.$t('trend 2')},
                { key: 'max_loss_repeat', label: this.$t('worst')},
                { key: 'last_bet', label: this.$t('Last Bet (W or L)')},
            ],
            loading: true
        }
    },
    created() {
        console.log('==============  created function')
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        ...mapActions([
                'getStatsByUserId'
            ]),
        
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>
<style scoped>
    .positive-mark {
        color: green
    }
    .negative-mark {
        color: red
    }
    .leverage_color_weight {
        background-color: #FFC000;
    }
    .leverage_color_light {
        background-color: #FFF2CC !important;
    }
    .comp_color_weight {
        background-color: #9BC2E6;
    }
    .comp_color_light {
        background-color: #DDEBF7 !important;
    }
    .cell_left_solid {
        /*border-left: solid !important;
        border-left-color: black !important;*/
        border-left: groove;
    }
    .cell_right_solid {
        /*border-right: solid !important;
        border-right-color: black !important;*/
        border-right: groove;
    }

</style>
<style>


.tips_financial_table_modify .table-responsive{
    margin-top: 20px !important;
    max-height: 80vh !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
.leverage_color_light {
    background-color: #FFF2CC !important;
}
.comp_color_weight {
    background-color: #9BC2E6;
}
.comp_color_light {
    background-color: #DDEBF7 !important;
}
.cell_left_solid {
    /*border-left: solid !important;
    border-left-color: black !important;*/
    border-left: groove;
}
.cell_right_solid {
    /*border-right: solid !important;
    border-right-color: black !important;*/
    border-right: groove;
}
.outcome-col {
    color:  white;
    min-width: 35px;
    display: inline-block;
    border-radius: 5px;
}
.green-background {
    background-color:  green;
}
.red-background {
    background-color:  red;
}
</style>